import styled from 'styled-components'

export const Wrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  ${({ centered }) => centered && 'bottom: 50%; transform: translateY(40%);'};
  ${({ centered }) => !centered && 'bottom: 40px;'};
  left: 0;

  width: 100%;
  padding-left: 100px;

  & form {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`
export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  max-width: 800px;
  flex-wrap: wrap;

  & button {
    padding: 8px 24px;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => `${theme.colors.secondary}50`};
  }
`
export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start; 
`
export const ColContainer = styled.div`
  display: flex;
  flex-direction: column; 
  max-width: 800px;
`
export const Title = styled.div`
  padding-right: 30px;

  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => `${theme.colors.primary}`};
`
export const Text = styled.div`  
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => `${theme.colors.primary}`};
`

export const Container = styled.div`
  max-width: 800px;
  width: 100%;
  border-radius: 18px;

  display: flex;
  align-items: center;
  padding-right: 10px;
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => `${theme.colors.secondary}50`};

  & input {
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: 50px;
    border: none;
    padding: 16px 25px;
  }
  & button {
    padding: 12px;
    border-radius: 12px;
  }
`
